const APP_URL = process.env.VITE_APP_URL
const BASE_URL = process.env.VITE_BASE_URL

export const defaultConfig = {
  title: 'Untitled',
  screenSize: {
    width: 1080,
    height: 1920
  },
  defaultPhotoRatio: 1 / 1,
  theme: {
    primaryColor: '#333333',
    secondaryColor: '#FBFBFB',
    backgroundColor: '#FBFBFB',
    fontFamily: 'Inter, sans-serif'
  },
  createdAt: new Date().toISOString(),
  updatedAt: new Date().toISOString(),
  thumbnail: `${BASE_URL}/assets/images/dreambooth-screen.png`,
  pages: [
    {
      id: 'welcome',
      name: 'Welcome',
      settings: {},
      components: [
        {
          type: 'image',
          src: `${APP_URL}/assets/images/dreambooth-icon.png`,
          alt: 'Dreambooth Icon',
          style: {
            top: '20%',
            left: '50%',
            transform: 'translate(-50%, 0)',
            width: '15%',
            height: 'auto'
          }
        },
        {
          type: 'text',
          content: 'Welcome to Dreambooth',
          style: {
            fontSize: '80px',
            color: '#333333',
            fontWeight: 'bold',
            textAlign: 'center',
            top: '52%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: '70%',
            height: 'auto'
          }
        },
        {
          type: 'nextButton',
          text: 'Click to Start',
          style: {
            bottom: '25%',
            left: '50%',
            transform: 'translate(-50%, 0)',
            backgroundColor: '#333333',
            color: '#FBFBFB',
            fontWeight: 'bold',
            fontSize: '40px',
            padding: '24px 32px',
            borderRadius: '9999px',
            width: '26%'
          }
        }
      ]
    },
    {
      id: 'filter',
      name: 'Filter',
      settings: {
        filters: [
          {
            id: 'normal',
            name: 'Normal',
            adjustments: {},
            owner: 'dreambooth',
            isPublic: true,
            isActive: true
          },
          {
            id: 'jelaga',
            name: 'Jelaga',
            adjustments: {
              contrast: 105,
              brightness: 120,
              saturation: 0,
              shadows: -17,
              vignette: 0.29,
              grain: 40,
              temperature: 15
            },
            owner: 'dreambooth',
            isPublic: true,
            isActive: true
          },
          {
            id: 'mentari',
            name: 'Mentari',
            adjustments: {
              brightness: 120,
              contrast: 100,
              shadows: -24,
              vignette: 0.15,
              grain: 30,
              temperature: 30
            },
            owner: 'dreambooth',
            isPublic: true,
            isActive: true
          },
          {
            id: 'vintage',
            name: 'Vintage',
            adjustments: {
              sepia: 50,
              contrast: 110,
              saturation: 85,
              vignette: 0.4,
              grain: 60
            },
            owner: 'dreambooth',
            isPublic: true,
            isActive: true
          },
          {
            id: 'dramatic',
            name: 'Dramatic',
            adjustments: {
              contrast: 130,
              shadows: -30,
              highlights: -10,
              saturation: 110,
              vignette: 0.45
            },
            owner: 'dreambooth',
            isPublic: true,
            isActive: true
          }
        ]
      }
    },
    {
      id: 'frame',
      name: 'Choose Frame',
      settings: {
        frameCategories: [{ id: 'all', name: 'All Frames' }],
        frameOptions: [
          {
            id: 'white-frame',
            name: 'Dreambooth White',
            owner: 'dreambooth',
            isPublic: true,
            isActive: true,
            baseImage: `${APP_URL}/assets/images/dreambooth-white.webp`,
            tags: ['all', 'brand2'],
            drawParams: {
              canvasWidth: 1200,
              canvasHeight: 1800,
              images: [
                {
                  type: 'frame',
                  src: `${APP_URL}/assets/images/dreambooth-white.webp`,
                  top: 0,
                  left: 0,
                  width: 1200,
                  height: 1800
                },
                {
                  type: 'photo-1',
                  top: 25,
                  left: 33,
                  width: 550,
                  height: 550
                },
                {
                  type: 'photo-2',
                  top: 590,
                  left: 33,
                  width: 550,
                  height: 550
                },
                {
                  type: 'photo-3',
                  top: 1155,
                  left: 33,
                  width: 550,
                  height: 550
                },
                {
                  type: 'photo-4',
                  top: 25,
                  left: 617,
                  width: 550,
                  height: 550
                },
                {
                  type: 'photo-5',
                  top: 590,
                  left: 617,
                  width: 550,
                  height: 550
                },
                {
                  type: 'photo-6',
                  top: 1155,
                  left: 617,
                  width: 550,
                  height: 550
                }
              ]
            }
          }
        ]
      }
    },
    {
      id: 'checkout',
      name: 'Checkout',
      settings: {
        packages: [
          {
            id: 'single',
            name: 'Single Copy',
            copies: 1,
            price: 35000,
            description: 'Perfect for personal use'
          },
          {
            id: 'double',
            name: 'Double Pack',
            copies: 2,
            price: 60000,
            description: 'Share with a friend',
            features: ['Save Rp 10.000']
          },
          {
            id: 'triple',
            name: 'Triple Pack',
            copies: 3,
            price: 72000,
            description: 'Best value',
            features: ['Save Rp 30.000', 'Most Popular']
          }
        ],
        promoEnabled: true,
        promoTimeout: 60,
        promos: [
          {
            code: 'DREAMBOOTH',
            type: 'fixed',
            value: 10000,
            dateStart: '2024-12-13',
            dateExpired: '2025-01-13',
            minPurchase: 35000,
            applicablePackages: ['double', 'triple']
          },
          {
            code: 'PROMO25',
            type: 'percentage',
            value: 25,
            dateStart: '2024-12-13',
            dateExpired: '2025-01-13',
            maxUsage: 100,
            applicablePackages: ['single', 'double', 'triple']
          }
        ]
      }
    },
    {
      id: 'payment',
      name: 'Payment',
      settings: {
        paymentTimeout: 60
      }
    },
    {
      id: 'capture',
      name: 'Capture',
      settings: {
        prepTimeout: 30,
        captureCountdown: 1,
        captureCount: 8,
        maxRetakeSession: 1
      }
    },
    {
      id: 'retake',
      name: 'Retake',
      settings: {
        maxRetakeCount: 3,
        retakeTimeout: 60
      }
    },
    {
      id: 'select',
      name: 'Select Photos',
      settings: {
        selectionTimeout: 60
      }
    },
    {
      id: 'result',
      name: 'Final Result',
      settings: {
        resultTimeout: 60
      }
    }
  ]
} as const

// Optional: Export type for type safety
export type DefaultConfig = typeof defaultConfig
